module.exports = __webpack_public_path__ + "static/FAQ-share3-5bce1d67162d9b4eeb5eb839375e642b.jpg";